export default {
  path: '/activity',
  meta: {
    title: '新人首单包退'
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/activity`),
}



// WEBPACK FOOTER //
// ./src/views/activity/router.js